<template>
    <div class="card">
        <div class="title">{{$t('推荐的云产品')}}</div>
        <ul class="rec-pack">
            <li v-for="(item, k) in data"
                :key="k"
                @click="productClick(item)"
                v-if="productTypeList.indexOf(item.idtype)!==-1">
                <div class="img"
                     :class="item.icon">
                    <!-- <img src="@/assets/images/console/dashboard/icon.png"> -->
                </div>
                <div class="con"
                     @click="$router.push({path:item.path})">
                    <span class="tit">
                        {{$t(item.name)}}
                        <a class="more"
                           v-show="ids[item.idtype]">
                            <i class="icon-arrow-under-o"></i>
                        </a>
                    </span>
                    <p>{{$t(item.description)}}</p>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'cloudproduct',
    props: ['ids', 'productTypeList'],
    components: {
    },
    data () {
        return {
            data: [
                { icon: 'cloudHD', path: '/mgt/modelarts', name: 'ModelArts产品', description: this.$t('ModelArts 是面向开发者的一站式 AI 平台，为机器学习与深度学习提供海量数据预处理及交互式智能标注、大规模分布式训练、自动化模型生成，及端-边-云模型按需部署能力，帮助用户快速创建和部署模型，管理全周期 AI 工作流。专属资源池为专业用户提供高性能，高效率的优化体验，资源池支持包周期计费，满足不同专业用户需求。'), idtype: 'ModelArts' },
                { icon: 'cloudHost', path: '/mgt/hpc', name: '高性能计算HPC', description: this.$t('HPC提供了超高浮点计算能力解决方案，可用于解决计算密集型、海量数据处理等业务的计算需求，如科学研究、气象预报、计算模拟、军事研究、CAD/CAE、生物制药、基因测序、图像处理等，缩短需要的大量计算时间，提高计算精度。'), idtype: 'HPC' }
            ]
        }
    },
    methods: {
        productClick (item) {
            // const id = this.ids[item.idtype]
            if (item.idtype === 'ModelArts') {
                this.hasPermission('CB19') && this.$router.push(item.path)
            } else if (item.idtype === 'HPC' || item.idtype === 'HPC-SAAS') {
                this.hasPermission('CB17') && this.$router.push(item.path)
            }
        }
    }
}
</script>
<style lang="less" scoped>
.rec-pack {
    display: flex;
    flex-wrap: wrap;
    margin: 0 10px;
    padding-bottom: 5px;
    font-size: 12px;
    // min-height: 200px;
    li {
        width: calc(~'33.333% - 10px');
        border: 1px solid #e9e9e9;
        margin: 0 5px 10px 5px;
        // height: 95px;
        display: flex;
        padding: 15px 10px;
        .con {
            flex-grow: 1;
            cursor: pointer;
        }
        .img {
            width: 31px;
            height: 31px;
            margin: 5px 14px 0 0;
            flex-shrink: 0;
            &.cloudHost {
                background-image: url('../img/cloudHost.svg');
            }
            &.cloudHD {
                background-image: url('../img/cloudHD.svg');
            }
            &.elasticIP {
                background-image: url('../img/elasticIP.svg');
            }
        }
        .tit {
            font-weight: 600;
            line-height: 25px;
            display: flex;
            justify-content: space-between;
        }
        .more {
            font-size: 12px;
            display: none;
            min-width: 50px;
            text-align: right;
            cursor: pointer;
            .icon-arrow-under-o {
                display: inline-block;
                transform: rotate(-90deg);
                color: #999999;
                font-size: 10px;
                font-weight: 600;
            }
        }
        p {
            color: #808080;
        }
        &:hover {
            box-shadow: 0px 3px 4px rgba(153, 153, 153, 0.2);
            .more {
                display: inline-block;
            }
        }
    }
}
</style>
